export default __webpack_public_path__ + "static/media/icon-eye-show.08ef5871.svg";